export const PROCESS_INTERRUPTED_BY_THE_USER = 'Process interrupted by the user';
export const PROCESS_CONDITION_MISMATCH = 'Process condition mismatch';
